export default class WindowsApis {
    constructor() {
        this.isWindows = window.Windows !== undefined;
    }

    listIaps = () => {
        if (this.isWindows) {
            let store = Windows.Services.Store;
            let context = store.StoreContext.getDefault();
            let queryResult = context.getStoreProductsAsync(["Durable"], ["9PNMTMLBSVR2"])
                .then((results) => console.log(results));
            //console.log(queryResult);
        }
    }

    purchaseRemoveAds = () => {
        return new Promise((resolve, reject) => {
            if (this.isWindows) {
                let store = Windows.Services.Store;
                let context = store.StoreContext.getDefault();
                let result = context.requestPurchaseAsync("9PNMTMLBSVR2")
                    .then((results) => {
                        console.log(store.StorePurchaseStatus.notPurchased);
                        if (results.status === store.StorePurchaseStatus.succeeded || results.status === store.StorePurchaseStatus.alreadyPurchased) {
                            resolve();
                        }
                        else {
                            reject();
                        }
                    });
            }
            else {
                reject();
            }
        });
    }

    isRemoveAdsPurchased = () => {
        return new Promise((resolve, reject) => {
            if (this.isWindows) {
                let store = Windows.Services.Store;
                let context = store.StoreContext.getDefault();
                let result = context.getAppLicenseAsync()
                    .then((results) => {
                        let addons = results.addOnLicenses;
                        for (let addon in addons) {
                            if (addon.startsWith('9PNMTMLBSVR2')) {
                                resolve();
                            }
                        }
                        reject();
                    });
            }
            else {
                reject();
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/api/WindowsApis.js